module.exports = __webpack_public_path__ + "h5/img/submit_success_b.1d734bac.jpg";